<div *ngIf="!isCXOne" class="challenges-top-area d-flex m-2 mt-3">
    <button type="button" class="challenges-back-button btn btn-text-gray btn-icon" (click)="cs.currentView = 0">
        <svg><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
        <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
    </button>
</div>

<div *ngIf="!isCXOne; else settingsTemplate" class="challenges-settings-container content mx-auto p-3 mt-3 nonModuleContainer" style="max-width: 800px;">
    <div *ngIf="!isSaving">
        <div>
            <p class="challenges-settings-question subtitle-1 lato-bold" cvLocalizedText langSection="Gamification_Admin_Messages" langKey="Allow_Creation_SameDayChallenge">
                Allow the creation of challenges that run on the same day they are created?
            </p>
        </div>
        <div class="mb-3">
            <div class="form-check">
                <input id="sameDayCheck" class="form-check-input mr-1" type="checkbox" [(ngModel)]="SameDayFlag" />
                <label class="form-check-label ml-1" for="sameDayCheck" cvLocalizedText langSection="Gamification_Admin_Messages" langKey="SameDayChallenge">Same Day Challenges</label>
            </div>
        </div>
    </div>
    <div *ngIf="!isSaving" class="challenges-settings-group-selection">
        <p class="challenges-settings-question subtitle-1 lato-bold" cvLocalizedText langSection="Challenges" langKey="Challenges_Operate_Level">Challenges should operate within what level?</p>
        <div class="challenges-settings-group-list d-flex">
            <div class="loadViewSmall height-width-admin" [hidden]="!isLoading"></div>
            <div class="challenges-settings-group-radio mr-5 px-1" *ngFor="let groupLevel of groupLevels">
                <div class="form-check pl-0">
                    <input type="radio" [id]="'level_0' + groupLevel" name="groupLevelName" class="mr-2" [value]="groupLevel" [checked]="(groupLevel == selectedGroupLevel)" (change)="onGroupChange(groupLevel)"/>
                    <label [for]="'level_0' + groupLevel">{{groupTypesByLevel[groupLevel]}}</label>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isSaving" class="challenges-settings-group-selection">
        <p class="challenges-settings-question subtitle-1 lato-bold" cvLocalizedText langSection="Challenges"
            langKey="Challenges_Types">Allow the creation of different types of challenge</p>
        <div class="challenges-settings-group-list d-flex">
            <div class="loadViewSmall loading-container" [hidden]="!isLoading"></div>
            <div *ngIf="!isLoading" class="d-flex">
                <div class="mr-3">
                    <div class="form-check">
                        <input id="battleboatCheck" class="form-check-input mr-1" type="checkbox"
                        [(ngModel)]="challengeTypes.battleBoats" />
                        <label class="form-check-label ml-1" for="battleboatCheck" cvLocalizedText
                            langSection="Challenges" langKey="BattleBoats">Battle Boats</label>
                    </div>
                </div>
                <div class="mr-3">
                    <div class="form-check">
                        <input id="shadowBoxingCheck" class="form-check-input mr-1" type="checkbox" 
                        [(ngModel)]="challengeTypes.shadowBoxing" />
                        <label class="form-check-label ml-1" for="shadowBoxingCheck" cvLocalizedText
                            langSection="Challenges_Create" langKey="Shadow_Boxing">Shadow Boxing</label>
                    </div>
                </div>
                <div class="mr-3">
                    <div class="form-check">
                        <input id="freeForAllCheck" class="form-check-input mr-1" type="checkbox"
                        [(ngModel)]="challengeTypes.freeForAll" />
                        <label class="form-check-label ml-1" for="freeForAllCheck" cvLocalizedText
                            langSection="Challenges" langKey="FreeForAll">Free For All</label>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isFormValid" [hidden]="isLoading" class="mt-1">
            <small class="warning-validation" cvLocalizedText langSection="Challenges" langKey="ChallengeType_Required">
                At least one challenge type must be selected
            </small>
        </div>
    </div>

    <div *ngIf="!isSaving" class="challenges-settings-metrics-selection mt-3">
        <div class="challenges-settings-metrics-label d-flex align-items-center">
            <div class="challenges-settings-question subtitle-1 lato-bold" cvLocalizedText langSection="Challenges" langKey="Select_Metric_Agent_Challenge">
                Select the metrics you would like your agents to challenge with.
            </div>
            <div id="challengesMetricSelector" class="challenges-settings-metric-selector ml-3" (click)="selectorDisabled ? $event.stopPropagation() : ''">
                <div class="loadViewSmall" style="height: 2.5rem; width: 10rem;"></div>
            </div>
        </div>
        <div class="challenges-settings-metrics-area-scroll-container w-100 border border-gray mt-3" style="min-height: 7.5rem; max-height: 10rem">
            <div class="challenges-settings-metrics-area p-2 d-flex flex-wrap">
                <div class="loadViewSmall height-width-admin" [hidden]="!isLoading"></div>
                <div class="challenges-settings-metric-pill rounded-pill text-body d-flex p-2 mr-2 mb-2 font-size-12" *ngFor="let metricID of selectedMetrics; let index = index">
                    <div class="challenges-settings-metric-pill-name ml-1">{{metricNames[metricID]}}</div>
                    <div class="challenges-settings-metric-pill-remove ml-3 my-auto" (click)="removeMetric(index)"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="loadView w-100" style="height: 30vh" *ngIf="isSaving && !isCXOne"></div>
    <cv-loader [size]="'large'" [overlay]="false" *ngIf="isSaving && isCXOne"></cv-loader>
    <div class="challenges-settings-button-holder d-flex w-100 mt-2">
        <button type="button" class="challenges-settings-save btn btn-primary ml-auto" [disabled]="isSaving || !isFormValid" (click)="saveSettings()">
            <span cvLocalizedText langSection="Common" langKey="Save_Button">Save</span>
        </button>
    </div>
</div>
<ng-template #settingsTemplate>
    <div class="row justify-content-between align-items-center m-3">
        <p class="mb-0 align-middle custom-setting-text" [ngClass]="{ 'legacy-styles-title': isCXOne }" cvLocalizedText langSection="Common" langKey="Settings">Settings</p>
        <div>
            <sol-button type="button" [variant]="'basic'" class="ml-auto mr-2" [size]="'large'" [disabled]="isSaving" (click)="cs.currentView = 0">
                <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
            </sol-button>
            <sol-button type="button" [variant]="'primary'" class="ml-auto" [size]="'large'" [disabled]="isSaving" (click)="saveSettings()">
                <span cvLocalizedText langSection="Common" langKey="Save_Button">Save</span>
            </sol-button>
        </div>
    </div>
    <div class="challenges-list challenges-settings-container nonModuleContainer pl-3 pr-3 max-width-admin">
         <div class="mb-3">
            <div class="form-check">
                <sol-checkbox checkboxId="sameDayCheck" class="form-check-input form-check-input-sch" [(ngModel)]="SameDayFlag" />
                <label class="form-check-label ml-1" for="sameDayCheck" [ngClass]="{ 'legacy-styles-body-default': isCXOne }" cvLocalizedText langSection="Gamification_Admin_Messages" langKey="SameDayChallenge">Same Day Challenges</label>
            </div>
        </div>
        <div class="challenges-settings-group-selection pb-3">
            <span class="text-uppercase" [ngClass]="{ 'legacy-styles-section': isCXOne, 'custom-item-style custom-font-weight' : !isCXOne }" cvLocalizedText langSection="Challenges" langKey="Level">Level</span>
            <div class="challenges-settings-group-list d-flex pt-1">
                <div class="loadViewSmall height-width-admin" [hidden]="!isLoading"></div>
                <sol-radio-group [inline]="true" [(ngModel)]="selectedGroupLevel" [name]="'groupLevelName'" class="px-1">
                    <sol-radio-button *ngFor="let groupLevel of groupLevels" [id]="'level_0' + groupLevel" class="mr-5"
                        [value]="groupLevel" (clicked)="onGroupChange(groupLevel)">
                        {{groupTypesByLevel[groupLevel]}}
                    </sol-radio-button>
                </sol-radio-group>
            </div>
        </div>
        <div class="challenges-settings-metrics-label d-flex align-items-center">
            <div class="text-uppercase" [ngClass]="{ 'legacy-styles-section': isCXOne, 'custom-item-style custom-font-weight' : !isCXOne }" cvLocalizedText langSection="Challenges" langKey="Metrics">
                Metrics
            </div>
            <div [hidden]="isLoading">
                <div id="challengesMetricSelectorkk" class="cursor-pointer">
                    <button type="button" class="btn btn-text btn-icon fill-cerulean text-style-inputs text-basic-color btn-challenge-padding"
                            (click)="toggleMetricSelector()">
                        <svg>
                            <use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use>
                        </svg>
                       <span [ngClass]="{ 'legacy-styles-body': isCXOne }" cvLocalizedText langSection="Common" langKey="Add">Add</span>
                    </button>
                </div>
            </div>
            <div class="loadViewSmall height-width-admin height-width-admin" [hidden]="!isLoading"></div>
        </div>
        <div class="challenges-settings-metrics-area-scroll-container w-100 border border-gray mt-3 min-max-height">
            <div class="challenges-settings-metrics-area p-2 d-flex flex-wrap">
                <div class="loadViewSmall height-width-admin" [hidden]="!isLoading"></div>
                <div class="challenges-settings-metric-pill rounded-pill text-body d-flex p-2 mr-2 mb-2 font-size-12" *ngFor="let metricID of selectedMetrics; let index = index">
                    <div class="challenges-settings-metric-pill-name ml-1">{{metricNames[metricID]}}</div>
                    <div class="challenges-settings-metric-pill-remove ml-3 my-auto" (click)="removeMetric(index)"></div>
                </div>
            </div>
        </div>
        <span [ngClass]="{ 'legacy-styles-sub-section': isCXOne, 'text-box-style': !isCXOne }" cvLocalizedText langSection="Challenges" langKey="Number_Metrics">Up to 10 metrics</span>
    </div>
</ng-template>
